S.aZLibrary = {
    config: {},
    elements: {
        $pagination: null,
        $paginationEntry: null,
        $swiperContainer: null,
        $swiperWrapper: null,
        $librarySlides: null,
    },

    /** @var {jQuery} a-z btn */
    $btnChar: null,

    /** @var {jQuery} $fakeBtnChar */
    $fakeBtnChar: null,

    /** @var {Number} currentIndex */
    currentIndex: 0,

    init()
    {

    },

    start()
    {
        const $customSelectInstance = this.$module.find('.mod-custom-select-menu').module('customSelectMenu');
        $customSelectInstance.$libraryInstance = this;

        this.$btnChar = this.$module.find('.js-btn-char');

        // init swiper
        this.initSwiper();

        // add listener
        this.addListener();
    },

    initSwiper()
    {
        this.librarySwiper = new Swiper(this.elements.$swiperContainer[0], {
            slidesPerView: 1,
            direction: 'horizontal',
            autoHeight: true,
        });

        this.checkAndSlideToFirstActiveSlide();

        this.initButtonEvents();
    },

    checkAndSlideToFirstActiveSlide()
    {
        let neededInd, $firstNotEmptyOne;

        const $activeChar = this.$btnChar.filter('.is-active');

        if ($activeChar.length)
        {
            neededInd = $activeChar.eq(0).data('index');
        }
        else
        {
            $firstNotEmptyOne = this.$btnChar.filter(':not(.m-empty)');
            neededInd = $firstNotEmptyOne.data('index');
        }

        this.slideTo(neededInd);

        this.currentIndex = neededInd;
        this.$btnChar.eq(neededInd).addClass('is-active');
    },

    /**
     *
     * @param index
     */
    slideTo(index)
    {
        this.librarySwiper.slideTo(index, 0);
    },

    /**
     *
     * @param element
     */
    handleMobileSelect(element)
    {
        const $clickedChar = $(element);
        if ($clickedChar.hasClass('is-empty'))
        {
            return;
        }

        const index = parseInt($clickedChar.attr('data-type'), 10) - 1;

        // for reset on repsonsive listener
        this.currentIndex = index;

        this.setActiveChar(index);

        // slide to slide
        this.slideTo(index);
    },

    setActiveChar(index)
    {
        // set desktop char button active
        this.$btnChar.removeClass('is-active');

        if (!this.$btnChar.eq(index).hasClass('m-empty'))
        {
            this.$btnChar.eq(index).addClass('is-active');
            this.currentIndex = index;
            this.slideTo(index);
        }
        else
        {
            this.checkAndSlideToFirstActiveSlide();
        }
    },

    /**
     *
     */
    initButtonEvents()
    {
        this.$btnChar.on('click', (e) =>
        {
            const $el = $(e.currentTarget),
                index = $el.data('index');

            if ($el.hasClass('m-empty'))
            {
                return;
            }

            this.currentIndex = index;
            this.$btnChar.removeClass('is-active');

            $el.addClass('is-active');

            this.compareFakeBtn();
            this.slideTo(index);
        });
    },

    /**
     *
     */
    compareFakeBtn()
    {
        this.$fakeBtnChar.eq(this.currentIndex).click();
    },

    /**
     * only close the magnificPopup on mobile
     */
    addListener()
    {
        // add listener
        S.mq('tablet').addListener((e) =>
        {
            if (e.matches)
            {
                // tablet
                this.setActiveChar(this.currentIndex);
            }
            else
            {
                // add mobile class
                this.setActiveChar(this.currentIndex);
            }
        });
    },
};
